module.exports = __webpack_public_path__ + "media/components/assets/img/logo/lot-30a23147b1153cc59228f0ed67327c57.png";